 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Admin.Agency~Admin.Course~Admin.Language~Admin.News~Admin.Profile~Admin.RegionOfOrigin~Agent.Assignm~a9095eef":"Admin.Agency~Admin.Course~Admin.Language~Admin.News~Admin.Profile~Admin.RegionOfOrigin~Agent.Assignm~a9095eef","Admin.Agency~Admin.Course~Admin.Language~Admin.News~Admin.RegionOfOrigin~Agent.Assignment~Agent.Assi~29feb039":"Admin.Agency~Admin.Course~Admin.Language~Admin.News~Admin.RegionOfOrigin~Agent.Assignment~Agent.Assi~29feb039","Admin.Agency~Agent.Agency":"Admin.Agency~Agent.Agency","Admin.Agency":"Admin.Agency","Admin.Course":"Admin.Course","Admin.Language":"Admin.Language","Admin.News~Agent.Assignment~Agent.AssignmentRequest~Agent.Billing~Agent.BusinessRules~Agent.Contract~11c35114":"Admin.News~Agent.Assignment~Agent.AssignmentRequest~Agent.Billing~Agent.BusinessRules~Agent.Contract~11c35114","Admin.News~Agent.News~Ui":"Admin.News~Agent.News~Ui","Admin.News":"Admin.News","Agent.News":"Agent.News","Agent.Assignment~Agent.AssignmentRequest~Agent.Billing~Agent.BusinessRules~Agent.Contract~Agent.Reso~fde4afc9":"Agent.Assignment~Agent.AssignmentRequest~Agent.Billing~Agent.BusinessRules~Agent.Contract~Agent.Reso~fde4afc9","Agent.Assignment":"Agent.Assignment","Agent.AssignmentRequest":"Agent.AssignmentRequest","Agent.Billing":"Agent.Billing","Agent.Contract":"Agent.Contract","Agent.Resource":"Agent.Resource","Agent.StatisticsOld":"Agent.StatisticsOld","Customer.Assignment":"Customer.Assignment","Resource.Assignment":"Resource.Assignment","Agent.Customer~Agent.Feedback~Customer.Feedback~Resource.Feedback":"Agent.Customer~Agent.Feedback~Customer.Feedback~Resource.Feedback","Agent.Customer":"Agent.Customer","Ui":"Ui","Admin.RegionOfOrigin":"Admin.RegionOfOrigin","Agent.Feedback":"Agent.Feedback","Customer.Feedback":"Customer.Feedback","Resource.Feedback":"Resource.Feedback","Agent.Language":"Agent.Language","Agent.User":"Agent.User","Customer.InvoiceDetails":"Customer.InvoiceDetails","Customer.User":"Customer.User","Resource.SalaryDetails":"Resource.SalaryDetails","Agent.BusinessRules":"Agent.BusinessRules","Customer.Calendar~Resource.Calendar":"Customer.Calendar~Resource.Calendar","Customer.Calendar":"Customer.Calendar","Resource.Calendar":"Resource.Calendar","Agent.Statistics~Customer.Statistics":"Agent.Statistics~Customer.Statistics","Agent.Statistics":"Agent.Statistics","Customer.Statistics":"Customer.Statistics","Admin.Profile~Agent.Profile~Customer.Profile~Resource.Profile":"Admin.Profile~Agent.Profile~Customer.Profile~Resource.Profile","Admin.Profile":"Admin.Profile","Agent.Profile~Customer.Profile~Resource.Profile":"Agent.Profile~Customer.Profile~Resource.Profile","Agent.Profile":"Agent.Profile","Customer.Profile":"Customer.Profile","Resource.Profile":"Resource.Profile","Agent.Settings":"Agent.Settings","Agent.Agency":"Agent.Agency","Agent.Fortnox":"Agent.Fortnox","Customer.Sitemap":"Customer.Sitemap"}[chunkId]||chunkId) + "." + {"Admin.Agency~Admin.Course~Admin.Language~Admin.News~Admin.Profile~Admin.RegionOfOrigin~Agent.Assignm~a9095eef":"4ca4c153","Admin.Agency~Admin.Course~Admin.Language~Admin.News~Admin.RegionOfOrigin~Agent.Assignment~Agent.Assi~29feb039":"56f8d5ac","Admin.Agency~Agent.Agency":"28b84c5a","Admin.Agency":"a7a2768a","Admin.Course":"238cb19f","Admin.Language":"aa6d9d5d","Admin.News~Agent.Assignment~Agent.AssignmentRequest~Agent.Billing~Agent.BusinessRules~Agent.Contract~11c35114":"707db4f9","Admin.News~Agent.News~Ui":"e2204eea","Admin.News":"bc054dc7","Agent.News":"def1d193","Agent.Assignment~Agent.AssignmentRequest~Agent.Billing~Agent.BusinessRules~Agent.Contract~Agent.Reso~fde4afc9":"c9dcc1a1","Agent.Assignment":"d2003854","Agent.AssignmentRequest":"6a117d10","Agent.Billing":"79734445","Agent.Contract":"6b1ebadb","Agent.Resource":"ea4159be","Agent.StatisticsOld":"ed80d1f8","Customer.Assignment":"c711d836","Resource.Assignment":"5b1c7140","Agent.Customer~Agent.Feedback~Customer.Feedback~Resource.Feedback":"65e179e7","Agent.Customer":"098fd43e","Ui":"5c44fcb6","Admin.RegionOfOrigin":"3c27886c","Agent.Feedback":"df6d0b64","Customer.Feedback":"6692ab48","Resource.Feedback":"06a1a507","Agent.Language":"bcb17a56","Agent.User":"5f601c23","Customer.InvoiceDetails":"f29b33ed","Customer.User":"b12957a5","Resource.SalaryDetails":"6d8a456b","Agent.BusinessRules":"6c435544","Customer.Calendar~Resource.Calendar":"75269ed5","Customer.Calendar":"64f366b6","Resource.Calendar":"1cb603ab","Agent.Statistics~Customer.Statistics":"1d71b605","Agent.Statistics":"51b4fd0a","Customer.Statistics":"2ee71918","Admin.Profile~Agent.Profile~Customer.Profile~Resource.Profile":"f15225b9","Admin.Profile":"372535c7","Agent.Profile~Customer.Profile~Resource.Profile":"0923b03d","Agent.Profile":"43d98f7d","Customer.Profile":"64427d40","Resource.Profile":"3f2122f3","Agent.Settings":"29ab897b","Agent.Agency":"80278b2c","Agent.Fortnox":"72422461","Customer.Sitemap":"f5ec3c62","chunk-2d0a2d9a":"51fba881","chunk-2d0a4784":"d70eea37","chunk-2d0aa189":"9cd9792f","chunk-2d0ab89e":"cade89e7","chunk-2d0aecaf":"0046ad66","chunk-2d0af65b":"aa593721","chunk-2d0b60ef":"fe6e2d83","chunk-2d0b6e7b":"7f0e59e0","chunk-2d0b9dc6":"0e570830","chunk-2d0ba87e":"36323d32","chunk-2d0bdf27":"548f5d49","chunk-2d0c519a":"6b963317","chunk-2d0c7360":"78aa9b48","chunk-2d0c7382":"90388e8e","chunk-2d0c7b02":"bf3e17e2","chunk-2d0c85dc":"05647923","chunk-2d0c8643":"5608882a","chunk-2d0cba58":"32277937","chunk-2d0d07a8":"3b5a11cf","chunk-2d0d5bef":"76e8e848","chunk-2d0d5fff":"bc5dcd0e","chunk-2d0d6561":"2a3a0c29","chunk-2d0d65f0":"8b814c40","chunk-2d0d67a0":"8fc26b5c","chunk-2d0d799a":"c89734df","chunk-2d0db121":"797dc523","chunk-2d0db286":"03ff8023","chunk-2d0dd4db":"f8b274e6","chunk-2d0de570":"6698c72d","chunk-2d0de752":"4486b679","chunk-2d0e1bb2":"b96c09f5","chunk-2d0e453b":"deaab582","chunk-2d0e48ee":"34f2904e","chunk-2d0e4ab9":"5f4d6456","chunk-2d0e9cd7":"e47c5f81","chunk-2d0f02bc":"427e9593","chunk-2d2079e1":"b7b40cfb","chunk-2d2084db":"5a4dfef2","chunk-2d20e855":"2cf7e9be","chunk-2d20f518":"555c3156","chunk-2d20faad":"beb1669c","chunk-2d212ff4":"3c0050a9","chunk-2d213b47":"194726fb","chunk-2d2161d9":"8096987b","chunk-2d21b8c9":"74451248","chunk-2d21e576":"de5416ce","chunk-2d224a92":"2b135a21","chunk-2d224fe8":"2729333f","chunk-2d226338":"14b10a1f","chunk-2d230665":"a047f7ed","chunk-2d231016":"d0d8f8d5","chunk-2d23794d":"e9276569","chunk-2d23803b":"57f0fcdb","chunk-772153cd":"b4121206"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
